<template>
  <div>
    <h3>Games!!</h3>
    <ul>
      <li>
        <router-link to="/codenames" link>
          codenames
          <!-- <span class="font-weight-light">a website</span> -->
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { db } from "../../firebase";
import wordBank from "@/assets/words";
export default {
  // mounted() {
  //   this.newGame();
  // },
  data() {
    return {
      teamUp: "",
      toggle_player: 0
    };
  },
  computed: {},
  firestore() {
    return {
      gameState: db.collection("gameState").doc("0")
    };
  },

  methods: {
    gameOver() {
      // this.gameState.words.forEach(word => {
      //   word.guessed = true;
      // });
    },
    updateFirestore() {
      this.$firestore.gameState.update({
        words: this.gameState.words,
        status: this.gameState.status,
        blueLeft: this.gameState.blueLeft,
        redLeft: this.gameState.redLeft
      });
    },

    newGame() {
      let first = ["blue", "red"][Math.floor(Math.random() * 2)];
      let second = first == "blue" ? "red" : "blue";
      this.teamUp = first;
      let teams = [];
      teams.push(first);
      for (let i = 0; i < 8; i++) {
        teams.push(first);
        teams.push(second);
      }
      for (let i = 0; i < 7; i++) {
        teams.push("beige");
      }
      teams.push("grey");
      for (let i = teams.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i);
        const temp = teams[i];
        teams[i] = teams[j];
        teams[j] = temp;
      }

      this.toggle_player = 0;
      this.gameState.words = [];
      this.gameState.status = "progress";
      this.gameState.blueLeft = first == "blue" ? 9 : 8;
      this.gameState.redLeft = first == "red" ? 9 : 8;

      let i = 0;
      while (this.gameState.words.length < 25) {
        let word = wordBank[
          Math.floor(Math.random() * wordBank.length)
        ].toUpperCase();
        if (!(this.word in this.gameState.words)) {
          this.gameState.words.push({
            word: word,
            guessed: false,
            team: teams[i]
          });
          i++;
        }
      }
      this.updateFirestore();
    },
    getClass(idx) {
      let team = this.gameState.words[idx].team;
      let guessed = this.gameState.words[idx].guessed;

      //player
      if (this.toggle_player == 0) {
        if (guessed) {
          //player guessed
          return team == "red"
            ? "player player__red"
            : team == "blue"
            ? "player player__blue"
            : team == "beige"
            ? "player player__beige"
            : "player player__black";
        } else if (!guessed && this.gameState.status == "over") {
          return team == "red"
            ? "player player__unguessed-red"
            : team == "blue"
            ? "player player__unguessed-blue"
            : "player player__unguessed";
        } else {
          //player unguessed
          return "player player__unguessed";
        }
        // spymaster
      } else {
        if (guessed) {
          //spymaster guessed
          return team == "red"
            ? "spymaster spymaster__red"
            : team == "blue"
            ? "spymaster spymaster__blue"
            : team == "beige"
            ? "spymaster spymaster__beige"
            : "spymaster spymaster__black";
        } else {
          //spymaster unguessed
          return team == "red"
            ? "spymaster spymaster__unguessed-red"
            : team == "blue"
            ? "spymaster spymaster__unguessed-blue"
            : team == "beige"
            ? "spymaster spymaster__unguessed-beige"
            : "spymaster spymaster__unguessed-black";
        }
      }
    },

    guessWord: function(idx) {
      this.gameState.words[idx].guessed = true;

      // check state

      // calc blue left and red left
      let blueLeft = this.gameState.words.filter(
        word => word.team == "blue" && word.guessed == false
      ).length;
      let redLeft = this.gameState.words.filter(
        word => word.team == "red" && word.guessed == false
      ).length;
      this.gameState.blueLeft = blueLeft;
      this.gameState.redLeft = redLeft;

      if (this.gameState.words[idx].team == "grey") {
        this.gameState.status = "over";
        this.gameOver();
      }
      this.updateFirestore();

      // this.words[idx].guessed = !this.words[idx].guessed;
    }
    // getWords: function() {
    //   this.$firestore.words;
    // }
    // addUser: function() {
    //   this.$firestore.users.add({
    //     name: this.newUser,
    //     weight: this.newWeight,
    //     time: this.newDate,
    //     timestamp: new Date()
    //   });
    //   this.newUser = "";
    //   this.newWeight = "";
    //   this.newDate = "";
    // },
    // deleteUser: function(user) {
    //   this.$firestore.users.doc(user[".key"]).delete();
    // },
    // deleteItem(user) {
    //   confirm("Are you sure you want to delete this item?") &&
    //     this.$firestore.users.doc(user[".key"]).delete();
    // }
  }
};
</script>
<style lang="scss" >
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.words {
  margin: 2rem 0rem;
  width: 80vw;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(5, 19%);
  grid-template-rows: repeat(5, 70px);
  grid-auto-flow: column;
  @media only screen and (max-width: 600px) {
    font-size: 52%;
  }
}
.word {
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 100%;
  // flex: 0 0 18%;
  // margin: 0.2rem;
  user-select: none;
  border-radius: 1rem;
  // height: 3rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0.2rem 0.2rem 0.2rem rgba(0, 0, 0, 0.5);
}
.redLeft {
  padding: 0.5rem;
  color: #d13030;
}
.blueLeft {
  padding: 0.5rem;
  color: #4183cc;
}

.player {
  &__red {
    color: white;
    background-color: #d13030;
  }

  &__blue {
    color: white;
    background-color: #4183cc;
  }
  &__beige {
    color: black;
    background-color: beige;
  }
  &__black {
    color: white;
    background-color: black;
  }

  &__unguessed {
    &-red {
      background-color: #d130307c;
    }
    &-blue {
      background-color: #4182cc71;
    }
  }
}
.spymaster {
  font-weight: bold;
  pointer-events: none;
  cursor: not-allowed;
  &__red {
    color: white;
    background-color: #d13030;
  }

  &__blue {
    color: white;
    background-color: #4183cc;
  }
  &__beige {
    color: black;
    background-color: beige;
  }
  &__black {
    color: white;
    background-color: black;
  }

  &__unguessed {
    &-red {
      color: #d13030;
      background-color: #d130301a;
    }
    &-blue {
      color: #4183cc;
      background-color: #4182cc21;
    }
    &-beige {
      color: black;
    }
    &-black {
      color: black;
      background-color: grey;
    }
  }
}
</style>